export default "__VITE_ASSET__94145d39__"